<script setup lang="ts">
import { MODAL_CENTER, MODAL_SIDE } from '@/const';

import { useModalStore } from '@/stores/modal.store';

const { variant, preventClose = false } = defineProps({
  variant: {
    type: String,
    default: MODAL_CENTER,
  },
  preventClose: {
    type: Boolean,
    default: false,
  }
});
const { closeModal } = useModalStore();
const emit = defineEmits<{
  (e: 'close'): void;
}>();

function close(e: Event) {
  e.stopPropagation();
  if (preventClose) return;
  emit('close');
  closeModal();
}
</script>

<template>
  <div
    @click="close"
    :class="[
      'xmodal-wrapper',
      {
        'xmodal-wrapper__side': variant === MODAL_SIDE,
        'xmodal-wrapper__center': variant === MODAL_CENTER,
      },
    ]"
    v-bind="$attrs"
  >
    <div @click.stop class="xmodal">
      <img
        src="@/assets/img/close-img.svg"
        @click="close"
        class="xmodal-close"
      />

      <div class="xmodal-header">
        <h3 v-if="$slots.title" class="xmodal-title">
          <slot name="title" />
        </h3>
      </div>

      <div v-if="$slots.default" class="xmodal-body">
        <slot />
      </div>

      <div v-if="$slots.footer" class="xmodal-footer">
        <slot :close="close" name="footer" />
      </div>
    </div>
  </div>
</template>
